import { z } from 'zod/v4';

import { legacyBag } from '../../../legacy-leaf';
import { sectionCommonShapeLegacy, sectionSpecificDataSchemaLegacy, sectionSpecificStylesSchemaLegacy } from './data';

/**
 * Row of the header/footer block. Same envelope as the default section plus its
 * own `data` / `styles` bags — both optional on the host type, so both stay
 * `nullish()` here.
 */
export const sectionLegacySpecificV0Schema = z.object({
    ...sectionCommonShapeLegacy,
    type: z.literal('specific'),
    data: legacyBag(sectionSpecificDataSchemaLegacy),
    styles: legacyBag(sectionSpecificStylesSchemaLegacy),
});
